const productGliderCustom = (glideInstance) => {
  //custom logic for product slider and videos
  glideInstance.on('run.after', () => {
    const video = glideInstance.selector.querySelector(`[data-media-index="${glideInstance.index}"][data-media-video] video`);
    if (video) {
      glideInstance.selector.classList.add('video-active');
      video.muted = true;
      video.currentTime = 0;
      video.play();
      return
    }
    glideInstance.selector.classList.remove('video-active')
    const videos = glideInstance.selector.querySelectorAll('[data-media-video] video')
    videos.forEach(vid => {
      vid.muted = true;
      vid.pause();
      vid.currentTime = 0;
    })
  })
}

export default productGliderCustom